// parts/header.js — accessible mobile menu toggle
ready(() => {
    const header = find('.site-header');
    if (!header) return;

    const toggle = header.find('.site-header-toggle');
    const panel = header.find('.site-header-panel');
    const body = document.body;

    if (toggle && panel) {
        const isOpen = () => body.classList.contains('mobile-header-open');

        const setOpen = (open) => {
            body.classList.toggle('mobile-header-open', open);
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
        };

        toggle.on('click', () => setOpen(!isOpen()));

        // close when a nav / language link is used
        panel.findAll('a').forEach((a) => a.on('click', () => setOpen(false)));

        // close on Escape, return focus to the toggle
        document.on('keydown', (e) => {
            if (e.key === 'Escape' && isOpen()) {
                setOpen(false);
                toggle.focus();
            }
        });

        // close on click outside the header
        document.on('click', (e) => {
            if (isOpen() && !header.contains(e.target)) {
                setOpen(false);
            }
        });
    }
});
